import { CommonEntity } from './Common'

export const DATA_MODEL_SCHEMA_RESOURCE_KINDS = {
  KNOWLEDGE: 'knowledge',
  VALIDATION: 'validation',
  INTERNAL: 'internal',
} as const

export type DataModelSchemaResourceKind = typeof DATA_MODEL_SCHEMA_RESOURCE_KINDS[keyof typeof DATA_MODEL_SCHEMA_RESOURCE_KINDS]

export interface DataModelSchemaResourceList extends CommonEntity {
  name: string
  file: string
  content_type: string
  encoding: string
  model: string
  kind: DataModelSchemaResourceKind
}

export interface DataModelSchemaResourceDetail extends CommonEntity {
  name: string
  file: string
  content_type: string
  encoding: string
  model: string
  kind: DataModelSchemaResourceKind
}

export interface DataModelSchemaResourcePreview {
  content: string
  content_type: string
  encoding: string
}

export interface CreateDataModelSchemaResourceRequest {
  model: string
  name: string
  file: File
  content_type: string
  encoding?: string
  kind: DataModelSchemaResourceKind
}

export interface UpdateDataModelSchemaResourceRequest {
  name?: string
  file?: File
  content_type?: string
  encoding?: string
  kind?: DataModelSchemaResourceKind
}
